import { Controller } from "@hotwired/stimulus"

// Fenêtre de détail (« pop up » de la maquette) : <dialog> natif, fermeture par Échap,
// par la croix ou par un clic sur le voile.
export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    event.preventDefault()
    this.opener = event.currentTarget
    this.dialogTarget.showModal()
    document.documentElement.classList.add("has-dialog-open")
    this.dialogTarget.addEventListener("close", this.closed, { once: true })
  }

  backdrop(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }

  closed = () => {
    document.documentElement.classList.remove("has-dialog-open")
    this.opener?.focus()
  }
}
